import {
  Disclosure,
  DisclosureButton,
  DisclosurePanel,
} from "@headlessui/react";

import { ChevronRightIcon } from "@heroicons/react/20/solid";

import orgData from "../organizationData";
import sideMenuScreens from "../sideMenu";
import { useLocation, useNavigate } from "react-router";
import React, { useEffect, useRef } from "react";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function SideMenu({ user, sideMenu, isAdmin, setOpen, open }) {
  const navigate = useNavigate();
  const location = useLocation(); // Get the current location
  const Data = isAdmin ? orgData : sideMenuScreens;
  const containerRef = useRef(null);
  const activeItemRef = useRef(null);
  const activeGroupButtonRef = useRef(null);

  useEffect(() => {
    if (!open) return;
    if (activeGroupButtonRef.current) {
      const isExpanded =
        activeGroupButtonRef.current.getAttribute("aria-expanded") === "true";
      if (!isExpanded) {
        activeGroupButtonRef.current.click();
      }
    }
    const scrollToActive = () => {
      if (activeItemRef.current && containerRef.current) {
        try {
          activeItemRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        } catch (e) {
          activeItemRef.current.scrollIntoView(true);
        }
      }
    };
    const id = setTimeout(scrollToActive, 80);
    return () => clearTimeout(id);
  }, [open, location.pathname]);
  return (
    <div
      ref={containerRef}
      className="flex grow flex-col h-screen gap-y-5 overflow-y-auto border-r border-gray-200 bg-white"
    >
      <nav className="flex flex-1 flex-col">
        <ul role="list" className="flex flex-1 flex-col gap-y-7 ">
          <li>
            <ul role="list" className="-ml-2 mb-15">
              {Data?.map((item) => {
                const hasAccess =
                  (!item.orgId || item.orgId === user?.orgId) && // Ensure orgId matches or is not present
                  ((item.value === "Home" && true) ||
                    (isAdmin &&
                      item.portalRole?.includes(
                        user?.portalRole?.toString()
                      )) ||
                    item.value in sideMenu);

                if (hasAccess) {
                  let screenName = item.value;
                  let mm = { ...sideMenu };
                  // const isActiveTab = location.pathname === item.to;

                  // Check if any sub-tab matches the current location
                  const isSubTabActive = item?.subgroup?.some((subItem) =>
                    location.pathname.startsWith(subItem.to)
                  );
                  const isActiveTab =
                    location.pathname.startsWith(item.to) || isSubTabActive;

                  return (
                    <li key={item.id}>
                      {!item.subgroup ? (
                        <Disclosure
                          as="div"
                          className={classNames(
                            isActiveTab
                              ? "bg-[#FFF7E8]"
                              : "hover:bg-[#FFF7E8] text-gray-700"
                          )}
                        >
                          <DisclosureButton
                            onClick={() => {
                              setOpen(false);
                              navigate(item.to);
                            }}
                            className={classNames(
                              "group flex gap-x-5 w-full text-left items-center rounded-md py-2 text-[1rem] font-small px-4"
                            )}
                            ref={isActiveTab ? activeItemRef : null}
                          >
                            <img
                              src={item.Icon}
                              alt="icon"
                              className="w-[30px] h-[30px] mr-2"
                            />
                            {/* <item.Icon
                              aria-hidden="true"
                              className="text-gray-400 text-4xl"
                            /> */}

                            <span className="flex-1 py-1">{item.label}</span>
                          </DisclosureButton>
                        </Disclosure>
                      ) : (
                        <Disclosure as="div" defaultOpen={isSubTabActive}>
                          <DisclosureButton
                            className={classNames(
                              item.current ? "bg-[#FFF7E8]" : "hover:bg-[#FFF7E8]",
                              "group flex w-full items-center gap-x-5 rounded-md py-2 text-left text-[1rem] font-small text-gray-700 px-4"
                            )}
                            ref={isSubTabActive ? activeGroupButtonRef : null}
                          >
                            <img
                              src={item.Icon}
                              alt="icon"
                              className="w-[30px] h-[30px] mr-2"
                              // className="w-8 h-8"
                            />
                            {item.label}
                            <ChevronRightIcon
                              aria-hidden="true"
                              className="ml-auto size-5 shrink-0 text-gray-400 group-data-open:rotate-90 group-data-open:text-gray-500"
                            />
                          </DisclosureButton>
                          <DisclosurePanel as="ul" className="mt-1 px-5">
                            {item?.subgroup.map((subItem) => {
                              if (
                                (isAdmin &&
                                  (subItem?.orgId
                                    ? user?.orgId === subItem?.orgId
                                    : subItem?.portalRole?.includes(
                                        user.portalRole.toString()
                                      ))) ||
                                (mm[screenName] &&
                                  mm[screenName].includes(subItem.label))
                              ) {
                                const isActiveSubTab =
                                  location.pathname === subItem.to;
                                return (
                                  <li key={subItem.label}>
                                    {/* 44px */}
                                    <DisclosureButton
                                      as="div"
                                      onClick={() => {
                                        setOpen(false);
                                        navigate(subItem.to);
                                      }}
                                      className={classNames(
                                        isActiveSubTab
                                          ? "bg-[#FFF7E8]"
                                          : "hover:bg-[#FFF7E8] text-gray-700",
                                        "block rounded-md py-1 text-sm/6"
                                      )}
                                    >
                                      <div
                                        onClick={() => {
                                          setOpen(false);
                                          navigate(item.to);
                                        }}
                                        className={classNames(
                                          item.current
                                            ? "bg-[#FFF7E8]"
                                            : "hover:bg-[#FFF7E8]",
                                          "group flex gap-x-5 rounded-md p-2 text-[1rem] text-gray-700"
                                        )}
                                        ref={
                                          isActiveSubTab ? activeItemRef : null
                                        }
                                      >
                                        <img
                                          src={subItem.SubIcon}
                                          alt="icon"
                                          className="w-[20px] h-6 object-contain mr-2"
                                        />
                                        {subItem.label}
                                      </div>
                                    </DisclosureButton>
                                  </li>
                                );
                              }
                              return null;
                            })}
                          </DisclosurePanel>
                        </Disclosure>
                      )}
                    </li>
                  );
                }
                return null;
              })}
            </ul>
          </li>
        </ul>
      </nav>
    </div>
  );
}
